import { ExceptionService } from '../services/exception.service';
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import {
  TogetherAuctionDIPApplicantDetails,
  TogetherAuctionDIPOutcome_DIP,
} from './../models/api.models';
import { TogetherDIPStageContainer } from './../models/app.models';
import { NodeAPIService } from './../services/node.api.service';
import { NodeAPIEntityService } from './../services/node.entity.service';
import * as _ from 'lodash-es';
import numeral from 'numeral';
import { DipStateService } from '../services/dip-state-service.service';
import { TogetherAuctionDIPEntityType, RateType } from 'app/models/enums';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'together-auction-dip-outcome-details',
    templateUrl: './dip.outcome_details.component.html',
    providers: [NodeAPIService, NodeAPIEntityService],
    standalone: false
})
export class TogetherAuctionDIPOutcomeDetailsComponent implements OnInit {

  @Input() propertyType: string;
  @Input() isDip: boolean;
  @Input() incomingCaseId: string;
  @Input() stage: TogetherDIPStageContainer;
  @Output() stageChanging = new EventEmitter();
  outcome: TogetherAuctionDIPOutcome_DIP = new TogetherAuctionDIPOutcome_DIP();

  actionText: string = 'Your offer details';
  forwardText: string = 'Progress to full application';
  isLoading: boolean = false;
  closeResult: string;
  selectedOption: string;

  /**
   * Defaults if the user does not get lower rate.
   *
   * @type {RateType}
   * @memberof TogetherAuctionDIPOutcomeDetailsComponent
   */
  selectedRateType: string = '';

  /**
   *
   *
   * @type {boolean}
   * @memberof TogetherAuctionDIPOutcomeDetailsComponent
   */
  isReducedRateProduct: boolean;

  /**
   *
   *
   * @type {boolean}
   * @memberof TogetherAuctionDIPOutcomeDetailsComponent
   */
  isProductSelected: boolean;

  /**
   *
   *
   * @type {boolean}
   * @memberof TogetherAuctionDIPOutcomeDetailsComponent
   */
  isOfferEligible: boolean;

  /**
   * Selected rate type.
   *
   * @param {any} type
   * @memberof TogetherAuctionDIPOutcomeDetailsComponent
   */
  selectRateType(type, isReducedRate) {
    this.selectedRateType = type;
    this.isReducedRateProduct = isReducedRate;
    this.isProductSelected = false;
  }

  get isSteppedProduct() {
    return _.isNil(this.selectedRateType) ? false : this.selectedRateType.indexOf('LR') >= 0;
  }

  /**
   * Fetch the DIP certificate from the server
   *
   * @memberof TogetherAuctionDIPOutcomeDetailsComponent
   */
  handleGetDIPCertificate() {
    const cert = this.entity.getDIPCertificate(this.incomingCaseId);
    // tslint:disable-next-line:max-line-length
    const windowOptions = 'menubar=no,toolbar=no,scrollbars=no,resizable=yes,top=300,left=300,width=800,height=1000';
    window.open(cert, 'DIP Certificate', windowOptions);
  }

  handleEditDip() {
    this.stageChanging.emit('tad_stage_edit');
  }

  handleForward() {
    this.stageChanging.emit(this.stage.forward_stage.reference);
  }

  get formattedLoanAmount() {
    return numeral(this.outcome.LoanAmount).format('0,0');
  }

  get formattedMonthlyInstallment() {
    return numeral(this.outcome['Products'][0].InitialRepayment).format('0,0.00');
  }

  get formattedSteppedonthlyInstallment() {
    const initialRepayment = this.isSteppedProductAvailable ?
      this.outcome['Products'][1].InitialRate : 0;
    return numeral(initialRepayment).format('0,0.00');
  }

  get formattedInitialRate() {
    return numeral(this.outcome['Products'][0].InitialRate).format('0.00');
  }

  get formattedSteppedInitialRate() {
    const initialRate = this.isSteppedProductAvailable ?
      this.outcome['Products'][1].InitialRate : 0;
    return numeral(initialRate).format('0.00');
  }

  get formattedNomialRage() {
    const nominalRange = _.isArray(this.outcome.Products) &&
      _.isEmpty(this.outcome.Products) === false ?
      this.outcome.Products[0].InitialRate : 0;
    return numeral(nominalRange / 100).format('0.00%');
  }

  get isSteppedProductAvailable() {
    const length = _.isArray(this.outcome.Products) &&
      _.isEmpty(this.outcome.Products) === false ? this.outcome.Products.length : 0;
    return length === 2;
  }

  get isOnlyOneProductAvailable() {
    const length = _.isArray(this.outcome.Products) &&
      _.isEmpty(this.outcome.Products) === false ? this.outcome.Products.length : 0;
    return length === 1;
  }


  /**
   * Forcibly updates the title if the
   *
   * @memberof TogetherAuctionDIPOutcomeDetailsComponent
   */
  forceOverrideTitle() {
    if (_.toInteger(this.outcome.Outcome) === 3) {
      this.state.overridePageTitle('Even top athletes make a false start occasionally.');
    }
    if (_.toInteger(this.outcome.Outcome) === 1) {
      if (this.isOnlyOneProductAvailable) {
        this.state.overridePageTitle('Your pre-approval');
      } else {
        this.state.overridePageTitle('Congratulations!');
      }
      this.state.overridePageSummary(
        `<h5 class="my-1">
                We're delighted to pre-approve a loan of:
                </h5>
                <h3 class="mb-3 font-source">
                £${this.formattedLoanAmount}
                </h3>`);
    }
  }

  /**
   *
   *
   * @memberof TogetherAuctionDIPOutcomeDetailsComponent
   */
  requote() {
    if (_.isNil(this.isReducedRateProduct)) {
      this.isProductSelected = true;
      return;
    }
    this.isLoading = true;
    const self = this;
    //requote
    this.api.requote(this.incomingCaseId, this.selectedRateType).subscribe(
      (success) => {
        const data = JSON.parse(success['_body']);
        this.state.overridePageTitle('Your pre-approval');
        this.state.overridePageSummary(
          `<h5 class="my-1">
                    We're delighted to pre-approve a loan of
                    </h5>
                    <h3 class="mb-3 font-source">
                    £${this.formattedLoanAmount}
                    </h3>`);
        self.outcome = new TogetherAuctionDIPOutcome_DIP(data);
        this.isLoading = false;
      },
    );
  }



  /**
   *
   *
   * @memberof TogetherAuctionDIPOutcomeDetailsComponent
   */
  ngOnInit() {
    this.isLoading = true;
    var self = this;

    this.entity.getAllEntities(TogetherAuctionDIPEntityType.Detail, this.incomingCaseId)
      .subscribe(

        (success) => {
          self.outcome = new TogetherAuctionDIPOutcome_DIP(success as Object);
          self.state.DipOutcome = _.defaultTo(success['Outcome'], 0);
          const selectedProduct = _.filter(self.outcome['Products'], (x) => {
            if (x['IsSelectedProduct'] === true) {
              return x['PlanCode'];
            }
          });
          if (self.isOnlyOneProductAvailable) {
            self.isOfferEligible = true;
          }
          self.selectedRateType = _.isArray(selectedProduct) &&
            _.isEmpty(selectedProduct) ?
            null : selectedProduct[0]['PlanCode'];
          // self.isReducedRateProduct = self.isSteppedProduct;
          self.forceOverrideTitle();
          self.isLoading = false;
        },
        (error) => {
          self.exception.haveReceivedError(error);
          self.isLoading = false;
        },
      );
  }

  /**
   *
   * ng-bootstrap Modal Open Function
   * @param {any} content
   * @memberof TogetherAuctionDIPOutcomeDetailsComponent
   */
  open(content) {
    // debugger;
    this.modalService.open(content, {
      // Defines modal size
      size: 'lg',
    }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  constructor(private entity: NodeAPIEntityService,
    private api: NodeAPIService,
    private modalService: NgbModal,
    private state: DipStateService,
    private exception: ExceptionService) { }
}


